import React, { useState, useEffect } from 'react'
import Main from '../Main'
import randomColor from 'randomcolor'
import Color from 'color-converter'
import Gradient from "javascript-color-gradient";
import copy from 'copy-to-clipboard';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ColorCard from './ColorCard'
import BackToService from './BackToService';


function ColorPicker() {
    var feelingRed = ['#FF6263', '#DE4839', '#BF3325', '#E21717', '#BF3312', '#D82E2F', '#EB4D4B', '#EF5354', '#B4161B', '#E6425E', '#E83A59', '#B9345A'];
    var feelingBlue = ['#1B98F5', '#23C4ED', '#383CC1', '#12B0E8', '#51E1ED', '#207398', '#46B2E0', '#03203C', '#3944F7', '#2827CC', '#120E43', '#5DA3FA'];
    var feelingGreen = ['#1FAA59', '#38CC77', '#02B290', '#50DBB4', '#3DBE29', '#4DD637', '#1C8D73', '#66AD47', '#22CB5C', '#6AC47E', '#6EC72D', '#00D84A'];
    var feelingYellow = ['#E8BD0D', '#EDBF69', '#F4BE2C', '#EDC126', '#E5D68A', '#DDD101', '#D9D55B', '#F7CD2E', '#AF9D5A', '#C7C11A', '#F4CE6A', '#A77B06'];
    var feelingFancy = ['#8D3DAF', '#E07C24', '#758283', '#E03B8B', '#FF6666', '#242B2E', '#03C6C7', '#5A20CB', '#6A1B4D', '#CAD5E2', '#35BDD0', '#0D0D0D'];

    const [isStatic, setIsStatic] = useState(true);
    const [colorName, setColorName] = useState("red");
    const [colorLength, setColorLength] = useState(10);
    const [colors, setColors] = useState([]);


    const copyColors = (e) => {
        copy(colors);
        toast('Copied', {
            type: "success",
        });
    }

    const actiontaken = () => {
        let staticChange = isStatic;
        setIsStatic(!staticChange);
    }

    const copyColorsTypeBase = (e) => {
        if (e.target.id === "red") {
            copy(feelingRed);
        } else if (e.target.id === "blue") {
            copy(feelingBlue);
        } else if (e.target.id === "green") {
            copy(feelingGreen);
        } else if (e.target.id === "yellow") {
            copy(feelingYellow);
        } else if (e.target.id === "fancy") {
            copy(feelingFancy);
        } else {
            copy([]);
        }
        toast('Copied', {
            type: "success",
        });
    }
    const fetchColors = () => {
        let selectedColors = colorName.split(",");
        let colors = [];
        if (selectedColors.length > 1) {
            let colorArray = [];
            const colorGradient = new Gradient();
            for (let i = 0; i < selectedColors.length; i++) {
                let colorFun = Color.fromCSS(selectedColors[i].trim());
                colorArray.push(colorFun.css());
            }
            colorGradient.setMidpoint(colorLength);
            colorGradient.setGradient(...colorArray);
            colors = colorGradient.getArray();
        } else {
            colors = randomColor({
                count: colorLength,
                hue: colorName
            })
        }
        setColors(colors);
    }

    useEffect(() => {
        fetchColors();
    }, []);

    if (isStatic) {
        return (
            <>
                <Main active="service">
                    <ToastContainer autoClose={2000} />
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>Color Picker <BackToService /></h2>
                                <header style={{ "textAlign": "center", "marginBottom": "15px", "position": "relative" }}><h1 class="copy-div">Click to Copy</h1>
                                    <h3>Always perfect color</h3>
                                    <button className="btn btn-xs btn-primary colors-btn" onClick={actiontaken} style={{ "position": "absolute", "right": "0" }}><i className="bx bx-search" style={{ "marginRight": "5px" }}></i>Generate Color</button>
                                </header>
                                <div style={{ "border": "1px solid lightgray", "borderRadius": "15px", "padding": "10px" }}>
                                    <h5 style={{ "marginBottom": "20px" }}>Feeling Red <i title="click to copy all colors" id="red" onClick={copyColorsTypeBase} className="bx bx-copy copy-board"></i></h5>
                                    <div className="row">
                                        {
                                            feelingRed.map((value) => {
                                                return <ColorCard color={value} />
                                            })
                                        }
                                    </div>
                                </div>
                                <div style={{ "border": "1px solid lightgray", "borderRadius": "15px", "padding": "10px", "marginTop": "25px" }}>
                                    <h5 style={{ "marginBottom": "20px" }}>Feeling Blue <i title="click to copy all colors" id="blue" onClick={copyColorsTypeBase} className="bx bx-copy copy-board"></i></h5>
                                    <div className="row">
                                        {
                                            feelingBlue.map((value) => {
                                                return <ColorCard color={value} />
                                            })
                                        }
                                    </div>
                                </div>
                                <div style={{ "border": "1px solid lightgray", "borderRadius": "15px", "padding": "10px", "marginTop": "25px" }}>
                                    <h5 style={{ "marginBottom": "20px" }}>Feeling Green <i title="click to copy all colors" id="green" onClick={copyColorsTypeBase} className="bx bx-copy copy-board"></i></h5>
                                    <div className="row">
                                        {
                                            feelingGreen.map((value) => {
                                                return <ColorCard color={value} />
                                            })
                                        }
                                    </div>
                                </div>
                                <div style={{ "border": "1px solid lightgray", "borderRadius": "15px", "padding": "10px", "marginTop": "25px" }}>
                                    <h5 style={{ "marginBottom": "20px" }}>Feeling Yellow <i title="click to copy all colors" id="yellow" onClick={copyColorsTypeBase} className="bx bx-copy copy-board"></i></h5>
                                    <div className="row">
                                        {
                                            feelingYellow.map((value) => {
                                                return <ColorCard color={value} />
                                            })
                                        }
                                    </div>
                                </div>
                                <div style={{ "border": "1px solid lightgray", "borderRadius": "15px", "padding": "10px", "marginTop": "25px" }}>
                                    <h5 style={{ "marginBottom": "20px" }}>Feeling Fancy <i title="click to copy all colors" id="fancy" onClick={copyColorsTypeBase} className="bx bx-copy copy-board"></i></h5>
                                    <div className="row">
                                        {
                                            feelingFancy.map((value) => {
                                                return <ColorCard color={value} />
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Main>
            </>
        )
    } else {
        return (
            <>
                <Main active="service">
                    <ToastContainer autoClose={2000} />
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>Color Picker <BackToService /></h2>
                                <header style={{ "textAlign": "center", "marginBottom": "15px", "position": "relative" }}><h1 class="copy-div">Click to Copy</h1>
                                    <h3>Always perfect color</h3>
                                    <button className="btn btn-xs btn-primary colors-btn" onClick={actiontaken} style={{ "position": "absolute", "right": "0" }}><i className="bx bx-search" style={{ "marginRight": "5px" }}></i>Go to static section</button>
                                </header>
                                <div style={{ "border": "1px solid lightgray", "borderRadius": "15px", "padding": "10px" }}>
                                    <h5>Feeling Crazy <i title="click to copy all colors" onClick={copyColors} className="bx bx-copy copy-board"></i></h5>
                                    <em>Search CSS color value (like "#aaa" or "red") or generate colors among given colors like (red,green,#efefef)</em>
                                    <div className="row" style={{ "marginTop": "15px" }}>
                                        <div className="col-md-8">
                                            <div className="input-group mb-3">
                                                <input type="text" className="form-control" value={colorName} onChange={(e) => setColorName(e.target.value)} placeholder="Color" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                                <input type="number" className="form-control" value={colorLength} onChange={(e) => setColorLength(e.target.value)} placeholder="Color Length" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                                <div className="input-group-append">
                                                    <button className="btn btn-primary" disabled={colorLength ? false : true} type="button" onClick={fetchColors}>Generate</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {
                                            colors.map((value) => {
                                                return <ColorCard color={value} />
                                            })
                                        }
                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                </Main>
            </>
        )
    }
}

export default ColorPicker
